import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { SessionStorageKey } from 'src/app/shared/enums/session-storage-key.enum';

import { JwtHelperService } from '@auth0/angular-jwt';
import { LoginService } from 'src/app/modules/public/modules/login/services/login.service';
import { SessionStorageService } from '../session-storage.service';
import { ToastService } from '../toast-service.service';
import { UserService } from '../user.service';

const ROUTES = ['/login', '/register', '/registers', '/home'];

@Injectable({
  providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {
  readonly empty = ' ';

  private login = '/login';
  private register = '/register';
  private steps = '/registers';
  private contact = '/home';

  constructor(
    private router: Router,
    private sessionStorageService: SessionStorageService,
    private userService: UserService,
    private loginService: LoginService,
    private toastService: ToastService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const [login] = ROUTES;
    /** Recuperando token do local storage */
    let token = this.sessionStorageService.getItem(SessionStorageKey.TOKEN);
    const type = this.sessionStorageService.getItem(
      SessionStorageKey.TOKEN_TYPE
    );

    // /** Verificando se existe token no local storage */
    if (!ROUTES.includes(this.router.url)) {
      if (token) {
        const jwtHelper = new JwtHelperService();
        /** 5 minutos em segundos */
        const TIME_IN_SECONDS = 300;

        /** Verificando se o accessToken expira em 5 minutos */
        if (jwtHelper.isTokenExpired(token, TIME_IN_SECONDS)) {
          /** Recuperando refreshToken do LocalStorage */
          const refreshToken = this.sessionStorageService.getItem(
            SessionStorageKey.REFRESH_TOKEN
          );

          this.loginService.sendRefreshToken(refreshToken).subscribe((data) => {
            this.sessionStorageService.storage(
              SessionStorageKey.TOKEN,
              data.access_token,
              Number(data.expires_in)
            );
            this.sessionStorageService.storage(
              SessionStorageKey.REFRESH_TOKEN,
              data.refresh_token,
              Number(data.refresh_expires_in)
            );
            this.sessionStorageService.storage(
              SessionStorageKey.EXPIRES_IN,
              data.expires_in
            );
          });

          token = this.sessionStorageService.getItem(SessionStorageKey.TOKEN);
        }
      }
    }

    if (
      !ROUTES.filter((r) => !r.startsWith('/login')).includes(this.router.url)
    ) {
      req = req.clone({
        setHeaders: {
          Authorization: `${type}${this.empty}${token}`,
          'zero1bit-client-platform': 'pesca',
        },
      });
    }

    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const res = event as HttpResponse<any>;
          if (res.status === 401) {
            this.redirect(this.login);
          }
        }
      }),
      catchError((e) => {
        if (e instanceof HttpErrorResponse) {
          const res = e as HttpErrorResponse;
          if (res.status === 401) {
            this.redirect(this.login);
          }
        }
        return throwError(() => e);
      })
    );
  }

  private redirect(url: string) {
    this.router.navigate([url]);

    this.toastService.showError(
      3000,
      'Seu acesso expirou!',
      'Faça login na aplicação para continuar.'
    );
  }
}
